'use client';

import { ColumnDef } from '@tanstack/react-table';

import { Price } from '@/components/atoms/price';
import { Link } from '@/components/link';
import { ApiSchemas } from '@/components/providers/v1-api';
import { Badge } from '@/components/ui/badge';

type ApiType = ApiSchemas['ServicePlanTemplateRead'];

export const SERVICE_PLAN_TEMPLATE_COLUMNS: ColumnDef<ApiType>[] = [
  {
    accessorKey: 'name',
    header: () => <div className='p-4'>Name</div>,
    cell: ({ row }) => {
      return (
        <Link href={`/settings/service_plans/${row.original.id}`} className='p-4 font-medium hover:underline'>
          {row.original.name}
        </Link>
      );
    },
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ row: { original } }) => {
      return (
        <Badge variant='secondary' className='capitalize'>
          {original.status.toLowerCase()}
        </Badge>
      );
    },
  },
  {
    header: 'Price (recurring)',
    accessorKey: 'prices',
    cell: ({ row: { original } }) => {
      const price = original.prices.find((v) => v.default) || original.prices[0];
      if (!price) {
        return '-';
      }
      return (
        <Badge variant='secondary'>
          <Price amount={price.amount_recurring ?? 0} currency={price.currency} />
        </Badge>
      );
    },
  },
  {
    header: 'Service Types',
    accessorKey: 'service_types',
    cell: ({ row: { original } }) => {
      if (original.service_type_templates.length === 0) {
        return '-';
      }

      return <Badge variant='secondary'>{original.service_type_templates.length}</Badge>;

      // const [first, ...rest] = original.service_type_templates;
      // return (
      //   <div className='flex max-w-[200px] gap-2'>
      //     <div
      //       key={first.id}
      //       className='bg-secondary text-secondary-foreground truncate rounded-md border border-transparent px-2 py-0.5 text-xs font-medium'
      //     >
      //       {first.name}
      //     </div>
      //     {rest.length > 0 && <Badge variant='secondary'>+ {rest.length}</Badge>}
      //   </div>
      // );
    },
  },
];
